import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { Subscription } from 'rxjs';

import { KitVideoService } from '../../../shared/services/apis/platform/kit.video.service';
import { KitVideoResponse } from '../../../shared/services/responses/platform/kit-video.response';
import { PlayerVideoComponent } from './player-video/player-video.component';
import { MenuComponent } from '../../../shared/components/menu/menu.component';
import { FooterComponent } from '../../../shared/components/footer/footer.component';
import { VideoStruct } from '../../../shared/services/structs/book-publish-edit.struct';

@Component({
  selector: 'app-my-shopping-videos',
  standalone: true,
  imports: [CommonModule, MenuComponent, FooterComponent, RouterModule],
  templateUrl: './my-shopping-videos.component.html',
  styleUrls: ['./my-shopping-videos.component.css']
})
export class MyShoppingVideosComponent implements OnInit, OnDestroy {
  public kitVideoData: KitVideoResponse | null = null;
  public isLoading = true;
  private routeSubscription: Subscription | undefined;
  _idKit: number;

  constructor(
    private route: ActivatedRoute,
    private kitVideoService: KitVideoService,
    public dialog: MatDialog
  ) { }

  ngOnInit(): void {
    this.routeSubscription = this.route.params.subscribe(params => {
      const idKit = +params['idKit'];
      this._idKit = idKit;
      if (idKit) {
        this.loadVideos(idKit);
      }
    });
  }

  ngOnDestroy(): void {
    if (this.routeSubscription) {
      this.routeSubscription.unsubscribe();
    }
  }

  private loadVideos(idKit: number): void {
    this.isLoading = true;
    this.kitVideoService.get(idKit).subscribe({
      next: (response) => {
        this.kitVideoData = this.prepareData(response);
        this.isLoading = false;
      },
      error: (error) => {
        console.error('Erro ao carregar os vídeos do kit', error);
        this.isLoading = false;
      }
    });
  }

  private prepareData(response: KitVideoResponse): KitVideoResponse {
    // Exemplo de como preparar dados mockados com base na API
    // No seu caso, o `isWatched` viria da API
    if (response && response.listVideoChapter) {
      response.listVideoChapter.forEach(chapter => {
        if (chapter.listVideoStruct) {
          chapter.listVideoStruct.forEach((video, index) => {
            // Para simular, vamos marcar alguns como vistos
            (video as any).isWatched = index % 3 === 0;
          });
        }
      });
    }
    return response;
  }

  public isPdf(url: string | undefined): boolean {
    return url?.toLowerCase().includes('.pdf') ?? false;
  }

  private getAllVideos(): VideoStruct[] {
    if (!this.kitVideoData || !this.kitVideoData.listVideoChapter) {
      return [];
    }
    return this.kitVideoData.listVideoChapter.reduce((acc, chapter) =>
      acc.concat(chapter.listVideoStruct), [] as VideoStruct[]);
  }

  public openVideoPlayer(selectedVideo: VideoStruct): void {
    const allVideos = this.getAllVideos();
    const currentIndex = allVideos.findIndex(v => v.idVideo === selectedVideo.idVideo);

    const dialogRef = this.dialog.open(PlayerVideoComponent, {
      width: '90vw',
      maxWidth: '1200px',
      height: 'auto',
      data: {
        videos: allVideos,
        currentIndex: currentIndex,
        idKit: this._idKit
      }
    });

    dialogRef.afterClosed().subscribe(() => {
      //Atualizar a lista de vídeos caso o status 'visto' tenha mudado
      this.loadVideos(this._idKit);
    });
  }
}